import { render } from "./LaboratoryQueueTab.vue?vue&type=template&id=4ec3c5bd"
import script from "./LaboratoryQueueTab.vue?vue&type=script&lang=js"
export * from "./LaboratoryQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__